import {
  first,
  group_by,
  merge,
  object_map,
  ordered_object,
  scan,
  sort_by,
} from "@pdfking/rfunc"
import { Identity, KeyTake, Zip, Partial, Values } from "@pdfking/tfunc"
import virtual from "@pdfking/workflow/vue/3/virtual"

import get_django_url from "../utils/get_django_url"
const decompress = ({ keys, values }, processor = a => a) =>
  object_map(first, c => processor(ordered_object(Zip(keys, c))), values)

const process_tag = tag => {
  tag.counter = 0
  return tag
}

const process_page = (tags, page) => {
  scan(t => (tags[t].counter += 1), page.tags)

  page.kind = tags[first(page.tags)]
  page.tags = KeyTake(tags, page.tags)

  page.kind_sequence = page.kind.sequence * 10000 + page.sequence

  return page
}

const public_autocomplete = [
  "regions",
  "public_pages",
  "switch",
  "imposition_preset",
  "standard_sizes",
]

export default virtual({
  computed: merge(
    object_map(
      Identity,
      name =>
        function () {
          this.load_autocomplete(name)
          return this.autocomplete[name]
        },
      public_autocomplete
    ),
    {
      pages_by_url() {
        if (this.pages_index) {
          return object_map(
            o => o.url,
            o => o,
            this.pages_index
          )
        }
      },
      pages_descendants_by_url() {
        if (this.pages_index) {
          return group_by(
            Values(this.pages_index),
            p => {
              if (p.parent) {
                const res = this.pages_index[p.parent]
                if (res) {
                  return res.url
                }
              }
            },
            objs => sort_by(objs, ["kind_sequence", "unicode"])
          )
        }
      },
      pages_index() {
        if (this.public_pages) {
          return decompress(
            this.public_pages.objects.pages,
            Partial(process_page, this.tags_index)
          )
        }
      },
      tags_index() {
        if (this.public_pages) {
          return decompress(this.public_pages.objects.tags, process_tag)
        }
      },
    }
  ),
  data: () => {
    return {
      autocomplete: object_map(Identity, () => null, public_autocomplete),
      loading: object_map(Identity, () => null, public_autocomplete),
      promise: object_map(Identity, () => null, public_autocomplete),
    }
  },
  methods: {
    load_autocomplete(name) {
      if (this.promise[name]) {
        return this.promise[name]
      }

      this.loading[name] = true
      this.promise[name] = get_django_url("autocomplete", {
        name,
      })
        .then(fetch)
        .then(r => r.json())
        .then(r => {
          this.autocomplete[name] = r
          this.loading[name] = false
          console.info("finished autoloading for " + name)

          return this.autocomplete[name]
        })

      return this.promise[name]
    },
  },
})
